import { render, staticRenderFns } from "./picture.vue?vue&type=template&id=554c63ae&scoped=true"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"
import style0 from "./picture.vue?vue&type=style&index=0&id=554c63ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c63ae",
  null
  
)

export default component.exports